module.exports = "<div class=modal-content> <div class=modal-header> <h4 class=modal-title ng-bind=vm.messageTitle></h4> </div> <div class=modal-body ng-bind-html=vm.message></div> <div class=modal-footer> <button class=\"btn btn-primary\" test-context=option-yes ng-click=vm.confirm() translate>Yes</button> <button class=\"btn btn-primary-outline\" test-context=option-no ng-click=vm.reject() type=button translate>No</button> <button class=\"btn btn-primary-outline\" test-context=option-cancel ng-click=vm.cancel() type=button translate>Cancel</button> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/common/dialogs/confirm-dialog.html
// module id = 581
// module chunks = 0